<template>
  <CodeScreenBase />
</template>

<script>
//import CodeScreen from './components/CodeScreen.vue'
//import CodeScreenContainer from '@/components/CodeScreenContainer.vue'
import CodeScreenBase from '@/components/CodeScreenBase.vue'
//import TestCircle from '@/components/TestCircle.vue'

export default {
  name: 'App',
  components: {
    //CodeScreen,
    CodeScreenBase,
    //TestCircle,
  },
  created() {
    screen.orientation.lock('portrait')
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;300;600&display=swap');
html,
body {
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}
</style>
